import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import TextField from "@material-ui/core/TextField";

const useStyles = makeStyles((theme) => ({
  helperTextRtl: {
    textAlign: "right",
  },

  formControlRtl: {
    right: 0,
  },

  inputLabelRtl: {
    transformOrigin: "top right",
  },
}));

const IntlTextField = (props) => {
  const { i18n } = useTranslation();
  const classes = useStyles();
  return (
    <TextField
      {...props}
      InputLabelProps={{
        classes: {
          root: clsx({
            [classes.inputLabelRtl]: i18n.dir() === "rtl",
          }),
          formControl: clsx({
            [classes.formControlRtl]: i18n.dir() === "rtl",
          }),
          shrink: clsx({
            [classes.inputLabelRtl]: i18n.dir() === "rtl",
          }),
        },
      }}
      FormHelperTextProps={{
        classes: {
          root: clsx({ [classes.helperTextRtl]: i18n.dir() === "rtl" }),
        },
      }}
    />
  );
};

export default IntlTextField;
